import { AAccentLineSize, AAccentLineAlignment } from '../../atoms/AAccentLine';
import { AEyebrowVariant } from '../../atoms/AEyebrow/AEyebrow.types';
import { AHeaderSize, AHeaderTag } from '../../atoms/AHeader/AHeader.types';

export enum MTextBlockStandardAlignment {
  Left = 'Left',
  Center = 'Center',
}

export interface MTextBlockStandardProps {
  alignment?: MTextBlockStandardAlignment;
  eyebrowText?: string;
  eyebrowVariant?: AEyebrowVariant;
  headerText: string;
  headerSize?: AHeaderSize;
  headerTag?: AHeaderTag;
  hasAccentLine?: boolean;
  accentLineSize?: AAccentLineSize;
  accentLineAlignment?: AAccentLineAlignment;
}
